const entradas_traslado = state => state.entradas_traslado;

export default {
  entradas_traslado,
};